import { useTranslation } from 'react-i18next';

// X-02: shared "rows per page" dropdown used by list screens
// (Policies, Offers, Claims, RiskSignals). Anjani flagged X-02 as
// Blocked with "Can not change from front-end" — the site had no way
// to pick page size, so power users couldn't skim large lists.
//
// Sizes chosen to match the backend limits accepted on ?limit= (all
// four list endpoints cap at 100). The 20 default is preserved from
// each screen's prior hardcoded PAGE_SIZE constant.
const DEFAULT_SIZES = [10, 20, 50, 100];

const PageSizeSelector = ({ pageSize, setPageSize, sizes = DEFAULT_SIZES, onChange }) => {
  const { t } = useTranslation();
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#64748b' }}>
      {t('common.rowsPerPage', { defaultValue: 'Rows per page' })}
      <select
        value={pageSize}
        onChange={(e) => {
          const next = Number(e.target.value);
          setPageSize(next);
          if (onChange) onChange(next);
        }}
        style={{
          padding: '4px 8px',
          border: '1px solid #e2e8f0',
          borderRadius: 6,
          background: '#fff',
          fontSize: 12,
          color: '#1e293b',
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        {sizes.map((s) => (
          <option key={s} value={s}>{s}</option>
        ))}
      </select>
    </label>
  );
};

export default PageSizeSelector;
